import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";
import { TrainingDetailPage } from "../training-detail/training-detail";

@IonicPage()
@Component({
  selector: "page-trainings",
  templateUrl: "trainings.html",
})
export class TrainingsPage {
  trainingStatus: "pending" | "completed" = "pending";

  constructor(private _navCtrl: NavController) {}

  handleTrainingClick(trainingId) {
    this._navCtrl.push(TrainingDetailPage, { trainingId });
  }

  handleStatusChange(status: "pending" | "completed") {
    this.trainingStatus = status;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/trainings/trainings.ts